/**
 * /portal/welcome (T-038, PR-07, DES-12).
 *
 * Bookmarkable surface for the welcome view. The transient version renders on
 * the dashboard (T-037) ahead of the kanban; this route is the addressable
 * copy referenced from notifications. Same component, same dismiss contract.
 */

import { createFileRoute, Link } from '@tanstack/react-router';
import { WelcomeView } from '@/components/portal/WelcomeView';

export const Route = createFileRoute('/portal/welcome')({
  component: WelcomePage,
});

function WelcomePage() {
  return (
    <div className="space-y-6">
      <WelcomeView />
      <p className="text-sm text-[color:var(--color-text-mute)]">
        Already read this?{' '}
        <Link
          to="/portal"
          className="font-medium underline underline-offset-4"
        >
          Go to your dashboard
        </Link>
        .
      </p>
    </div>
  );
}
